import React, { useState } from "react";
import { ExtendedUser } from "../../store/types";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { StyledIconLine } from "../StyledIcon/StyledIcon";
import { MediumText } from "../../styles/Typography";
import { IconUserFilled, IconCompanyFilled } from "../../assets/icons/Icon";
import { Column, SmallColumn } from "./Dialogs.styles";

interface DialogProps {
  visible: boolean;
  onHide: () => void;
  dialogType: string;
  user: ExtendedUser;
  sendLink: (id: string) => Promise<boolean>;
}

const SendLinkDialogs: React.FC<DialogProps> = ({
  visible,
  onHide,
  dialogType,
  user,
  sendLink,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!user) return;

    setSubmitting(true);
    let success = false;

    try {
      success = await sendLink(user.id);

      if (success) {
        onHide();
      }
    } finally {
      setSubmitting(false);
    }
  };

  const getHeader = (type: string) => {
    switch (type) {
      case "activation":
        return "Активация пользователя";
      case "resetPassword":
        return "Сброс пароля";
      default:
        return "Ошибка загрузки данных";
    }
  };

  const footer = (
    <div>
      <Button label="Отмена" onClick={onHide} outlined />
      <Button label="Отправить" onClick={handleSubmit} loading={submitting} />
    </div>
  );

  const getLabel = (type: string) => {
    switch (type) {
      case "activation":
        return "Отправить ссылку активации аккаунта данному пользователю?";
      case "resetPassword":
        return "Отправить ссылку сброса пароля данному пользователю?";
      default:
        return "";
    }
  };

  const formContent = (
    <Column>
      <MediumText>{getLabel(dialogType)}</MediumText>
      <SmallColumn>
        <StyledIconLine
          icon={<IconUserFilled size={20} />}
          text={
            user
              ? `${user.lastName ?? ""} ${user.name ?? ""} ${
                  user.patronymic ?? ""
                }`
              : ""
          }
        />
        <StyledIconLine
          icon={<IconCompanyFilled size={20} />}
          text={user?.organizationName ?? "Нет данных"}
        />
      </SmallColumn>
    </Column>
  );

  const getContent = (type: string) => {
    switch (type) {
      case "activation":
        return formContent;
      case "resetPassword":
        return formContent;
      default:
        return <></>;
    }
  };

  return (
    <Dialog
      header={getHeader(dialogType)}
      visible={visible}
      style={{ width: "500px" }}
      onHide={onHide}
      footer={footer}
    >
      {getContent(dialogType)}
    </Dialog>
  );
};

export default SendLinkDialogs;
